import React, { useState } from 'react'
import { apiDelete, apiGet, apiPost, apiPut } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { IconButton } from '@mui/material'
import { ManageSearchOutlined, NotificationsActiveOutlined } from '@mui/icons-material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import ProfilePermission from './ProfilePermission'
import AlarmSubscriptionDialog from '../alarmsubscriptions/AlarmSubscriptionDialog'

const Profiles = () => {
  const { t_ } = useSmartTranslation()
  const [permissionsDialog, setPermissionDialog] = useState({ open: false, profileId: null, profileName: null, systemDefault: true })
  // S118 (D11/CA7): first of the two doors to the subscriptions of a subject.
  const [subscriptionsDialog, setSubscriptionsDialog] = useState({ open: false, profileId: 0, profileName: '' })

  const columns = [{
    name: t_('Code'),
    field: 'code',
    charLimit: 70,
    mandatory: true,
    unique: true,
    readOnly: (row) => {
      return row.systemDefault
    }
  },
  {
    name: t_('Name'),
    field: 'name',
    charLimit: 70,
    mandatory: true,
    unique: true,
    readOnly: (row) => {
      return row.systemDefault
    }
  },
  {
    name: t_('Description'),
    field: 'description',
    charLimit: 200
  }
  ]

  const actions = {
    create: {
      fetchFunction: (row) => {
        return apiPost('profile', row)
      }
    },
    edit: {
      fetchFunction: (row) => {
        return apiPut('profile', row)
      }
    },
    delete: {
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('profile/' + rows[0].id)
        } else {
          return apiDelete('profileMulti', rows)
        }
      },
      visibilityButton: (row) => {
        return !row.systemDefault
      }
    },
    custom: [
      {
        name: 'View Permissions',
        render: (row) => {
          return (
            <IconButton>
              <ManageSearchOutlined />
            </IconButton>
          )
        },
        onClick: (row) => {
          setPermissionDialog({ open: true, profileId: row.id, systemDefault: row.systemDefault, profileName: row.name })
        }
      },
      {
        // S118: same row-action pattern as "View Permissions" above. No new permission (DN-6): the
        // guard is the one already protecting this screen.
        name: 'Alarm subscriptions',
        render: (row) => {
          return (
            <IconButton>
              <NotificationsActiveOutlined />
            </IconButton>
          )
        },
        onClick: (row) => {
          setSubscriptionsDialog({ open: true, profileId: row.id, profileName: row.name })
        }
      }
    ]
  }

  const fetchFunction = async (pagination) => {
    const profiles = await apiGet('profiles', pagination)
    return profiles
  }

  return (
    <>
      <SmartDialog
        setOpen={permissionsDialog.open}
        accept={false}
        close
        cancel={false}
        closeCallback={() => setPermissionDialog({ ...permissionsDialog, open: false })}
        renderComponent={<ProfilePermission profileId={permissionsDialog.profileId} systemDefault={permissionsDialog.systemDefault} profileName={permissionsDialog.profileName} />}
      />
      <SmartDialog
        setOpen={subscriptionsDialog.open}
        accept={false}
        close
        cancel={false}
        closeCallback={() => setSubscriptionsDialog({ ...subscriptionsDialog, open: false })}
        renderComponent={
          <AlarmSubscriptionDialog
            subjectType='PROFILE'
            subjectId={subscriptionsDialog.profileId}
            subjectName={subscriptionsDialog.profileName}
          />
        }
      />
      <SmartMateriaUITable
        columns={columns}
        title={t_('Profiles')}
        dataFetch={fetchFunction}
        actions={actions}
        multipleSelection
        pageable
      />
    </>
  )
}

export default Profiles
